
import { Component, Mixins } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, TruckModule } from "@/store/modules";
import * as modals from "@/lib/modals";

const orderModule = getModule(OrderModule);
const truckModule = getModule(TruckModule);

@Component({
  name: modals.truckOrderViewModal
})
export default class TruckOrderViewModal extends Mixins(mixin) {
  truckOrders: Array<any> = [];

  get currentTruck() {
    return truckModule.currentTruck;
  }

  get orders() {
    return orderModule.data;
  }

  display() {
    this.show();
  }
}
